/**
 * ISO instants for the start (inclusive) and end (exclusive) of the user's local calendar day.
 * Used as a fallback when the backend counts by IANA timezone.
 */
export function getLocalActiveTodayBoundsIso(): {
    activeTodayStart: string
    activeTodayEnd: string
} {
    const now = new Date()
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const end = new Date(start)
    end.setDate(end.getDate() + 1)
    return {
        activeTodayStart: start.toISOString(),
        activeTodayEnd: end.toISOString(),
    }
}

/** IANA zone from the browser; matches date-fns `format(..., date)` for last active display. */
export function getClientTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/** Params for table-rows so activeTodayCount matches the "Last Active" column (local calendar day). */
export function getLocalActiveTodayQueryParams(): {
    activeTodayStart: string
    activeTodayEnd: string
    clientTimeZone: string
} {
    return {
        ...getLocalActiveTodayBoundsIso(),
        clientTimeZone: getClientTimeZone(),
    }
}
